import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class EweService {

  private cdsBaseURL: string = "https://api.agroclimate.org";
  public timeInterval: any;

  constructor(private http: HttpClient) { }

  public getEweData(latitude, longitude, from, to, variable, threshold): Observable<any> {
    return this.http.get(this.cdsBaseURL + '/v2/ewe/ewe/lat/' + latitude + '/lon/' + longitude + '/from/' + from + '/to/' + to + '?&var[eq]=' + variable + '&threshold[eq]=' + threshold , { headers: { 'x-api-key': environment.apiKey } }).pipe(catchError(error => of(error)));
  }

}
